export default class Order {
  constructor(API) {
    this.api = API;
  }
  getProviderFromProduct(product) {
    return product.allowedProviders[0].toLowerCase();
  }
  isMonerisEnabledForProduct(product) {
    return this.getProviderFromProduct(product).indexOf("moneris") != -1;
  }
  isBraintreeEnabledForProduct(product) {
    return this.getProviderFromProduct(product).indexOf("braintree") != -1;
  }
  isStripeEnabledForProduct(product) {
    return this.getProviderFromProduct(product).indexOf("stripe") != -1;
  }
  //CC/Skip order
  async preOrder(productOrderObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/productOrder/pre/common`;
    req.body = productOrderObj;
    return await req.exec();
  }
  async beginOrder(productOrderObj, provider) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/productOrder/begin/${provider}`;
    req.body = productOrderObj;
    return await req.exec();
  }
  async completeOrder(productOrderObj, provider) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/productOrder/complete/${provider}`;
    req.body = productOrderObj;
    return await req.exec();
  }
  async deleteOrder(externalID, orderID) {
    const req = await this.api.newBaseRequest("DELETE");
    req.path = `/productOrder/${externalID}/${orderID}`;
    return await req.exec();
  }
  async cancelOrder(productOrderObj, provider) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/productOrder/cancel/${provider}`;
    req.body = productOrderObj;
    return await req.exec();
  }
  async refundOrder(productOrderObj, provider) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/productOrder/refund/${provider}`;
    req.body = productOrderObj;
    return await req.exec();
  }
  //Get order(s)
  async getProductOrder(externalID, orderID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/productOrder/${externalID}/${orderID}`;
    return await req.exec();
  }
  async getProductOrderExpanded(externalID, orderID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/productOrder/${externalID}/${orderID}/expanded`;
    return await req.exec();
  }
  async getProductOrdersByExternalID(externalID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/productOrders/" + externalID;
    return await req.exec();
  }
  async getProductOrdersFromToTimestamp(from, to) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/productOrders/report";
    req.appendQueryParam("from", from);
    req.appendQueryParam("to", to);
    return await req.exec();
  }
  async getProductOrdersByExternalID(externalID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/productOrders/" + externalID;
    return await req.exec();
  }
  async getProductOrderReceipt(externalID, orderID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/productOrder/${externalID}/${orderID}/receipt`;
    req.bodyType = "BINARY";
    return await req.exec();
  }
  async getProductOrderByID(orderID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/productOrder/${orderID}`;
    return await req.exec();
  }
  async markShipped(externalID, orderID, shippingObj) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = `/productOrder/${externalID}/${orderID}/shipped`;
    req.body = shippingObj;
    return await req.exec();
  }
  async searchProductOrders(filters) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/productOrders/search";
    if (filters) req.body = filters;
    return await req.exec();
  }
}
